// ─── El horario de una sección (H7) ─────────────────────────────────────────
//
// Cada entrada: día de la semana (0 = domingo), hora de inicio y de término en
// HH:mm —hora LOCAL del seminario, la de su zona horaria— y la sala o sede.
//
// UN HORARIO QUE EL EDITOR NO SABE LEER NO SE REESCRIBE. La importación de
// LABTS trae la hora de inicio sin hora de término (el Access no la tenía), y
// la guardó con `endTime === startTime`. Ese horario se muestra tal cual y se
// conserva al guardar la sección; solo cambia si alguien edita el horario a
// propósito (y entonces el horario nuevo sí tiene que ser completo y válido).
const HHMM = /^([01]\d|2[0-3]):[0-5]\d$/;
/** `null` si la entrada es completa y válida; si no, la CLAVE i18n del error. */
export function scheduleEntryProblem(e) {
    if (!Number.isInteger(e.dayOfWeek) || e.dayOfWeek < 0 || e.dayOfWeek > 6) {
        return 'section.schedule_invalid_day';
    }
    if (!HHMM.test(e.startTime) || !HHMM.test(e.endTime))
        return 'section.schedule_invalid_time';
    if (e.endTime <= e.startTime)
        return 'section.schedule_end_before_start';
    return null;
}
/** El primer problema de un horario nuevo, o `null`. */
export function scheduleProblem(entries) {
    for (const e of entries) {
        const p = scheduleEntryProblem(e);
        if (p)
            return p;
    }
    return null;
}
/** ¿El editor puede mostrar y editar este horario sin perder nada? Un horario
 *  importado sin hora de término (o con datos que no son HH:mm) NO: se muestra
 *  tal cual y se conserva. Uno vacío sí (no hay nada que perder). */
export function isEditableSchedule(entries) {
    return scheduleProblem(entries) === null;
}
//# sourceMappingURL=section-schedule.js.map